import API from '../../../../common/http/api.fetch';
import {GRID_FETCH, GRID_RELOAD} from "../../../../common/grid/grid.constants";
import { TYPES } from './adm-accounts-clients-action-type.constants';
import { IDS } from './adm-accounts-clients-action-id.constants';
import {success, responseMessage} from '../../../../common/utils/util.notifier';

export const fetchClientAccounts = (filter) => {
    return dispatch => {
        return API.fetch({
            url: '/location/client-accounts',
            method: 'GET',
            params: filter
        }).then(({data}) => {
            dispatch({
                type: GRID_FETCH,
                id: IDS.admAccountsClients,
                path: IDS.admAccountsClientsGrid,
                ...data,
            });
        });
    }
}

export const fetchClientAccountDetails = (client_uuid) => {
    return dispatch => {
        return API.fetch({
            url: `/location/client`,
            method: 'GET',
            params: { client_uuid }
        }).then(({data}) => {
            dispatch({
                type: TYPES.FETCH_CLIENT_ACCOUNT_DETAILS,
                id: IDS.admAccountsClients,
                data: data.params,
            });
        });
    }
}

export const  updateAccountsClientDetails = (data) => {
    return dispatch => {
        return API.fetch({
            url: '/location/client',
            method: 'PUT',
            data,
        }).then(response => {
            success('Changes Saved');
        }, error => {
            responseMessage(error);
        })
    }
}

export const removeClientAccount = (client_uuid) => {
    return (dispatch) => {
        return API.fetch({
            url: `/location/client`,
            method: 'DELETE',
            params: { client_uuid }
        }).then(response => {
            success('Client Account Removed');
            dispatch({
                type: GRID_RELOAD,
                id: IDS.admAccountsClients,
                path: IDS.admAccountsClientsGrid,
            })
        });
    }
}

export const fetchAccountsClientExternalRoles = (filter) => {
    return dispatch => {
        if (!filter.client_uuid) {
            return;
        }
        return API.fetch({
            url: `/location/client-external-roles`,
            method: 'GET',
            params: filter
        }).then(({data}) => {
            dispatch({
                type: GRID_FETCH,
                id: IDS.admAccountsClients,
                path: IDS.admAccountsClientExternalRolesGrid,
                ...data,
            });
        });
    }
}

export const addExternalRole = (data) => {
    return dispatch => {
        return API.fetch({
            url: '/location/add-client-external-role',
            method: 'POST',
            data,
        }).then(response => {
            success('External Role Added');
            dispatch({
                type: GRID_RELOAD,
                id: IDS.admAccountsClients,
                path: IDS.admAccountsClientExternalRolesGrid,
            });
        }, error => {
            responseMessage(error);
        });
    }
}

export const inactivateExternalRole = (data) => {
    return dispatch => {
        return API.fetch({
            url: '/location/inactivate-client-external-role',
            method: 'POST',
            data,
        }).then(response => {
            success('External Role Removed');
            dispatch({
                type: GRID_RELOAD,
                id: IDS.admAccountsClients,
                path: IDS.admAccountsClientExternalRolesGrid,
            });
        }, error => {
            responseMessage(error);
        });
    }
}

export const fetchOutsourcedManagementProviderOptions = () => {
    return dispatch => {
        return API.fetch({
            url: '/location/outsourced-management-providers',
            method: 'GET',
        }).then(({data}) => {
            dispatch({
                type: TYPES.FETCH_OUTSOURCED_MANAGEMENT_PROVIDER_OPTIONS,
                id: IDS.admAccountsClients,
                ...data,
            });
        });
    }
}

export const fetchSiteCapabilities = () => {
    return dispatch => {
        return API.fetch({
            url: '/location/site-capabilities',
            method: 'GET',
            params: {par_code: 'scapab'}
        }).then(({data}) => {
            dispatch({
                type: TYPES.FETCH_SITE_CAPABILITIES_OPTIONS,
                id: IDS.admAccountsClients,
                items: data,
            });
        });
    };
}